import i18n from '@/main';
import routesUtils from '@/utils/routes';
import locale from '@/views/contratos-originacao/parametros/locale';

export const beforeEnter = (to, _, next) => {
    const usuarioLogado = JSON.parse(sessionStorage.getItem('dadosUsuario'));
    const userHasRequiredRoles = routesUtils.userHasRequiredRoles(
        usuarioLogado,
        to.meta.roles
    );

    locale.init(i18n);
    userHasRequiredRoles ? next() : next('/');
};
